var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInclusion01 = function SvgInclusion01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "inclusion-01_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#inclusion-01_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.99 11.044a1.192 1.192 0 1 0 0-2.384 1.192 1.192 0 0 0 0 2.384ZM14.807 14.144H9.172a2.817 2.817 0 1 1 5.635 0ZM7.01 7.97a1.192 1.192 0 1 0 0-2.383 1.192 1.192 0 0 0 0 2.383ZM9.828 11.072H4.193a2.817 2.817 0 1 1 5.635 0ZM16.968 7.97a1.192 1.192 0 1 0 0-2.383 1.192 1.192 0 0 0 0 2.383ZM19.786 11.072H14.15a2.817 2.817 0 1 1 5.636 0ZM7.01 14.116a1.192 1.192 0 1 0 0-2.384 1.192 1.192 0 0 0 0 2.384ZM9.828 17.218H4.193a2.817 2.817 0 1 1 5.635 0ZM16.968 14.116a1.192 1.192 0 1 0 0-2.384 1.192 1.192 0 0 0 0 2.384ZM19.786 17.218H14.15a2.817 2.817 0 1 1 5.636 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "inclusion-01_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgInclusion01 as ReactComponent };